<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Mistakes' }" replace>错题订正</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Deatilm?type=0&jobSubmitId='+data.job_submit_id+'&status='+$route.query.status }" replace>待订正</el-breadcrumb-item>
				<el-breadcrumb-item>订正</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_list p_m_t_30 overflow small_hand" :style="{ height: height + 'px' }">
			<div class="list_head">
				<!-- <el-tag type="success" size="small " effect="dark">{{data.question.question_type_def}}</el-tag>
				<span class="type_size_22 p_m_l_20">1.(2021春•揭阳校级期中)下列对文章内容的理解和分析，不正确的一项是(   )</span> -->

				<p  class="type_size_20" style="line-height:1">
					<el-tag type="success" size="small" effect="dark">{{data.question.question_type_def}}</el-tag>
					({{data.question.year}})
				</p>
				<div class="type_size_22">
					<span v-html="data.question.title"></span>
				</div>

			</div>

			<!-- 单选题 -->
			<div class=" p_m_t_20" v-if="data.question.question_type == 1 " >
				<div class="" v-for="(val,key) in data.question.affiliation" :key="key" style="margin: 15px 0;">
					<el-radio :label="val.name" v-model="revised" class="p_flex">
						<p class="p_flex" style="font-size: 16px;">{{val.name}}、 <span v-html="val.text"></span></p>
					</el-radio>
				</div>
			</div>

			<!-- 多选题 -->
			<div class="p_m_t_20" v-if="data.question.question_type == 2" >
				<div class="" v-for="(val,key) in data.question.affiliation" :key="key" style="margin: 15px 0;">
					<el-checkbox :label="val.name" v-model="revised" class="p_flex">
						<p class="p_flex" style="font-size: 16px;">{{val.name}}、 <span v-html="val.text"></span></p>
					</el-checkbox>
				</div>
			</div>

			<!-- 判断题 -->
			<div class="p_flex p_m_t_20" v-if="data.question.question_type == 3" >
				<div>
					<el-radio label="A" v-model="revised">对</el-radio>
					<el-radio label="B" v-model="revised">错</el-radio>
				</div>
			</div>

			<!-- 填空题 -->
			<div class=" p_m_t_20 p_f_a" v-if="data.question.question_type == 4" >
				<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
					<el-input style="margin-top: 10px" v-if="data.question.answer_mode == 1 || data.question.answer_mode == 3" v-for="(val,key) in data.question.affiliation" :key="key" type="text" v-model="data.content[key].text" placeholder="请输入答案">
						<template slot="prepend">{{val.name}}、</template>
					</el-input>
				</div>
				<div class="upload-image p_m_t_20" v-if="data.question.answer_mode == 2 || data.question.answer_mode == 3">
					<div class="image-item" v-for="(val,key) in image" :key="key" >
						<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="image" />
						<span class="del-image" @click.stop="delImage(key,val)">×</span>
					</div>
					<el-upload style="width: 80px; height: 80px;"
						:action="$request.ajaxUrl+'/Upload/image/type/student'"
						:headers="$request.headers(true)"
						:show-file-list="false"
						list-type="picture-card"
						:multiple="false"
						:on-success="uploadImage">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
			</div>

			<!-- 问答题 -->
			<div class="p_m_t_20 p_f_a" v-if="data.question.question_type == 5">
				<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30">
					<el-input type="textarea" v-if="data.question.answer_mode == 1 || data.question.answer_mode == 3"  :autosize="{ minRows: 4}" v-model="revised" placeholder="请输入问题"></el-input>
				</div>
				<div class="upload-image" v-if="data.question.answer_mode == 2 || data.question.answer_mode == 3">
					<div class="image-item" v-for="(val,key) in image" :key="key" >
						<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="image" />
						<span class="del-image" @click.stop="delImage(key,val)">×</span>
					</div>
					<el-upload style="width: 80px; height: 80px;"
						:action="$request.ajaxUrl+'/Upload/image/type/student'"
						:headers="$request.headers(true)"
						:show-file-list="false"
						list-type="picture-card"
						:multiple="false"
						:on-success="uploadImage">
						<i class="el-icon-plus"></i>
					</el-upload>
				</div>
			</div>

			<!-- 材料题 -->
			<div class="p_flex  p_m_t_20 p_f_a" v-if="data.question.question_type == 6">
				<div class="p_f_1 p_m_l_30 type_size_18 p_m_r_30">
					<div v-for="(val,key) in data.question.affiliation" :key="key" style="margin: 15px; 0">
						<div style="font-size: 16px; line-height: 30px;" v-html="val.name"></div>
						<div style="margin: 20px 0; color: #000000; padding-left: 30px; box-sizing: border-box;" v-if="data.question.answer_mode == 1 || data.question.answer_mode == 3">
							<el-input style="margin-top: 10px;"  type="text" v-model="revised[key].text" placeholder="请输入答案">
								<template slot="prepend">答：</template>
							</el-input>
						</div>
					</div>

					<div class="upload-image" v-if="data.question.answer_mode == 2 || data.question.answer_mode == 3">
						<div class="image-item" v-for="(val,key) in image" :key="key" >
							<el-image style="width: 90px; height: 90px;" :src="val" :preview-src-list="image" />
							<span class="del-image" @click.stop="delImage(key,val)">×</span>
						</div>

						<el-upload style="width: 80px; height: 80px;"
							:action="$request.ajaxUrl+'/Upload/image/type/student'"
							:headers="$request.headers(true)"
							:show-file-list="false"
							list-type="picture-card"
							:multiple="false"
							:on-success="uploadImage">
							<i class="el-icon-plus"></i>
						</el-upload>
					</div>
				</div>
			</div>


			<!-- <div class="p_m_t_20">
				<crrect-picture></crrect-picture>
				<crrect-choice></crrect-choice>
				<crrect-more></crrect-more>
				<crrect-input></crrect-input>
				<crrect-textbox></crrect-textbox>
			</div> -->

			<el-button type="success"  style="margin: 50px; float: right;"  @click='submit' >保存</el-button>
		</div>

	</div>
</template>

<script>
	// 图片
import CrrectPicture from './components/picture.vue'
import CrrectChoice from './components/choice.vue'
import CrrectMore from './components/more.vue'
import CrrectInput from './components/input.vue'
import CrrectTextbox from './components/textbox.vue'
export default {
	name: 'Correcte',
	components:{ CrrectPicture, CrrectChoice,
		CrrectMore, CrrectInput, CrrectTextbox },
	data() {
		return {
			data:{ jobPublish:{}, jobRecord:{}, question:{} },
			height: 0,
			revised: null,
			image: [],
		};
	},
	mounted() {
		this.indexInfo();
		this.$request.ajax(this).post('api_student/wrong_question_detail',{ job_record_id:this.$route.query.id }).then(res=>{
			var data = res.data
			this.data = data
			if( data.question.question_type == 2 ){
				if( data.revised_content ){
					this.revised = data.revised_content.split('')
				}else{
					this.revised = data.content.split('')
				}
			}else{
				if( data.revised_content ){
					this.revised = data.revised_content
				}else{
					this.revised = data.content
				}
			}

			if( data.image && data.image.length != 0 ){
				if( data.revised_image ){
					this.image = data.revised_image
				}else{
					this.image = data.image
				}
			}

		})
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Correcte') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {

		submit(){
			var data = this.data
			var postData = {job_record_id:data.id, revised_image:this.image }
			// 验证答案
			if( data.question.question_type == 1 || data.question.question_type == 2 || data.question.question_type == 3 || data.question.question_type == 5 ){
				if( (!this.revised || this.revised.length == 0) && this.image.length == 0 ) return this.$message('请填写订正答案')
			}else{

			}
			var revised = ''
			for(let i=0; i<this.revised.length; i++){
				revised += this.revised[i]
			}
			if( data.question.question_type == 2 ){
				postData.revised_content = revised
			}else{
				postData.revised_content = this.revised
			}

			this.$request.ajax(this).post('api_student/wrong_revised',postData).then(res=>{
				this.$router.back(-1)
			})

		},

		uploadImage(e){
			this.image.push(e.data)
		},

		delImage(key,val){
			var _this = this
			this.$confirm('是否确认删除此图片?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '返回',
				type: 'warning'
			}).then(() => {
				var image = _this.image
				var newImage = []
				image.forEach((v,k)=>{
					if(val != v){
						newImage.push(v)
					}
				})
				_this.image = newImage
			})
		},

		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head  - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
	}
};
</script>
<style lang="scss" scoped>
.mine_list{
	background: #FFFFFF;
	padding: 0 60px 30px;
}
>>> .el-tag--dark.el-tag--success {
		background-color: #00af63;
		border-color: #00af63;
	}
	.list_head{
		padding-top: 60px;
	}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/correct.vue